import { FocusScope } from '@react-aria/focus';
import type { FunctionComponent, PropsWithChildren } from 'react';
import { useState } from 'react';
import FocusLock from 'react-focus-lock';

import Portal from '@atlaskit/portal';
import { useFeatureGate } from '@trello/feature-gate-client';
import { Key, Scope, useShortcut } from '@trello/keybindings';
import {
  ELEVATION_ATTR,
  getHighestVisibleElevation,
} from '@trello/layer-manager';

import styles from './AttachmentViewerContainer.less';

interface AttachmentViewerContainerProps {
  onClose: () => void;
}

export const AttachmentViewerContainer: FunctionComponent<
  PropsWithChildren<AttachmentViewerContainerProps>
> = ({ onClose, children }) => {
  const { value: isReactFocusLockEnabled } = useFeatureGate(
    'ghost_use_react_focus_lock',
  );
  const [elevation] = useState(() => getHighestVisibleElevation() + 1);

  useShortcut(onClose, { scope: Scope.Overlay, key: Key.Escape });

  return (
    <Portal zIndex={1}>
      {isReactFocusLockEnabled ? (
        <FocusLock autoFocus={true} returnFocus={true}>
          <div
            className={styles.container}
            {...{ [ELEVATION_ATTR]: elevation }}
          >
            {children}
          </div>
        </FocusLock>
      ) : (
        <FocusScope autoFocus contain restoreFocus>
          <div
            className={styles.container}
            {...{ [ELEVATION_ATTR]: elevation }}
          >
            {children}
          </div>
        </FocusScope>
      )}
    </Portal>
  );
};
